import type { ActivityLogRes, BaseErrorResponse } from './data-contracts';
import type { RequestParams } from './http-client';
import { HttpClient } from './http-client';


export default function useActivityLog() {
  class ActivityLog<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Activity log
     * @name ActivityLogControllerGeActivityLog
     * @summary Getting a list of activity log
     * @request GET:/api3/activity-log
     * @secure
     * @response `200` `ActivityLogRes`
     * @response `400` `BaseErrorResponse`
     */
    activityLogControllerGeActivityLog = (
      query?: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit?: number;
        /**
         * @min 0
         * @example 0
         */
        page?: number;
        /** @example "ProfileUpdateActivity" */
        activityType?: string;
        /** @example [{"0":{"field":"client-info.client"}},{"0":{"operation":"="}},{"0":{"value":"AdminApiClient"}}] */
        filter?: object;
        /**
         * Sort options
         * @example {"orderBy":{"client-info.adminId":"DESC"}}
         */
        orderBy?: object;
      },
      params: RequestParams = {},
    ) =>
      this.request<ActivityLogRes, BaseErrorResponse>({
        path: '/api3/activity-log',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Activity log
     * @name ActivityLogControllerGetProfileActivityLog
     * @summary Getting a list of profile activity log
     * @request GET:/api3/activity-log/profile
     * @secure
     * @response `200` `ActivityLogRes`
     * @response `400` `BaseErrorResponse`
     */
    activityLogControllerGetProfileActivityLog = (
      query?: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit?: number;
        /**
         * @min 0
         * @example 0
         */
        page?: number;
        /** @example "ProfileUpdateActivity" */
        activityType?: string;
        /** @example [{"0":{"field":"client-info.client"}},{"0":{"operation":"="}},{"0":{"value":"AdminApiClient"}}] */
        filter?: object;
        /**
         * Sort options
         * @example {"orderBy":{"client-info.adminId":"DESC"}}
         */
        orderBy?: object;
        /** @example 1 */
        accountId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ActivityLogRes, BaseErrorResponse>({
        path: '/api3/activity-log/profile',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new ActivityLog();
}
